(function () {
  'use strict';

  var TRACKING_FLAG = '__beefcakeClubActionsTracking';

  if (window[TRACKING_FLAG]) return;
  window[TRACKING_FLAG] = true;

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var action = target.closest('[data-beefcake-club-actions] [data-bc-action-key]');
    if (!action) return;

    var actionKey = action.getAttribute('data-bc-action-key');
    var placement = action.getAttribute('data-bc-placement');
    if (!actionKey || !placement) return;

    var detail = {
      event: 'club_earn_action_click',
      event_id: ['club_earn_action_click', Date.now(), actionKey].join('-'),
      page_path: window.location.pathname,
      action_key: actionKey,
      placement: placement
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({}, detail));

    document.dispatchEvent(new CustomEvent('beefcake:club-event', {
      detail: detail
    }));
  });
}());
